// API Configuration
import { API_BASE_URL as API_BASE_URL_CONFIG } from './config/apiConfig';

// Export API_BASE_URL for backward compatibility
// apiConfig.js already handles environment detection, so we just use it
export const API_BASE_URL = API_BASE_URL_CONFIG;

// Other configuration constants
export const APP_NAME = 'PsychePoint';
export const APP_VERSION = '1.0.0';

// Feature flags
export const FEATURES = {
    ENABLE_NOTIFICATIONS: true,
    ENABLE_CHAT: true,
    ENABLE_VIDEO_CALLS: true,
};

// Theme configuration
export const THEME = {
    PRIMARY_COLOR: '#4A90E2',
    SECONDARY_COLOR: '#F5A623',
    ERROR_COLOR: '#D0021B',
    SUCCESS_COLOR: '#7ED321',
    WARNING_COLOR: '#F5A623',
    INFO_COLOR: '#4A90E2',
};